import React from 'react'

interface AdminSettingsIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const AdminSettingsIcon: React.FC<AdminSettingsIconProps> = ({
  color = '#000',
  gradient,
  width = 26,
  height = 26,
  alt = 'Admin settings icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 26 26'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M17.8 24.375A3.375 3.375 0 0114.425 21v-4A2.575 2.575 0 0117 14.425c.345 0 .625-.28.625-.625v-2.941l1.017-1.017a.625.625 0 000-.884l-.758-.758.758-.758a.625.625 0 000-.884l-.758-.758.758-.758a.625.625 0 000-.884l-.758-.758L19.4 1.884l1.775 1.775V13.8c0 .345.28.625.625.625A2.575 2.575 0 0124.375 17v4A3.375 3.375 0 0121 24.375h-3.2zM13.175 21a4.625 4.625 0 004.625 4.625H21A4.625 4.625 0 0025.625 21v-4c0-1.9-1.385-3.476-3.2-3.774V3.4a.625.625 0 00-.183-.442l-2.4-2.4a.625.625 0 00-.884 0l-2.4 2.4a.625.625 0 000 .884l.758.758-.758.758a.625.625 0 000 .884l.758.758-.758.758a.625.625 0 000 .884l.758.758-.758.758a.625.625 0 00-.183.442v2.626a3.826 3.826 0 00-3.2 3.774v4zM4.375 7.4A4.627 4.627 0 009 12.023 4.627 4.627 0 0013.625 7.4 4.627 4.627 0 009 2.774 4.627 4.627 0 004.375 7.4zM9 10.773A3.377 3.377 0 015.625 7.4 3.377 3.377 0 019 4.024 3.377 3.377 0 0112.375 7.4 3.377 3.377 0 019 10.774z'
        clipRule='evenodd'
      ></path>
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M17.175 20.2a2.226 2.226 0 104.451-.002 2.226 2.226 0 00-4.451.002zm2.225.975a.976.976 0 11.002-1.952.976.976 0 01-.002 1.952zM2.6 24.375a.974.974 0 01-.975-.975v-4a7.375 7.375 0 0112.59-5.215l.095.096A3.814 3.814 0 0013.175 17v4c0 1.332.563 2.532 1.463 3.375H2.6zm-1.573.598c.417.417.983.652 1.573.652h12.8c.457 0 .9-.14 1.269-.398a.625.625 0 00-.124-1.093A3.377 3.377 0 0114.425 21v-4a2.57 2.57 0 011.131-2.132.625.625 0 00.134-.912A8.627 8.627 0 002.9 13.3 8.625 8.625 0 00.375 19.4v4c0 .59.234 1.156.652 1.573'
        clipRule='evenodd'
      ></path>
    </svg>
  )
}

export default AdminSettingsIcon
